@if (defaultImage) {
  <div>
    <img class="fade-in" [ngStyle]="_style.img" [ngClass]="{'img-circle': circle}" [src]="getImageUrl()" (load)="onImageLoaded()" (error)="onImageError()" />
  </div>
}
